import { Component, Input, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DTypeCol, DTypeComponent, DTypeFamilies, NextLocator } from '@grupo-constant/next-dtype/types';
import { BehaviorSubject, first } from 'rxjs';
import { DtypeFieldEditDialogComponent } from '../dtype-field-edit/dtype-field-edit.dialog';
import { DTypeService } from '../dtype.service';

// TODO DELETE
@Component({
    selector: 'dtype-fieldtypelist',
    templateUrl: './dtype-fieldtypelist.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DtypeFieldtypelistComponent implements OnInit {

    @Input() columns$: BehaviorSubject<DTypeCol[]>;
    @Input() locator: NextLocator;

    isLoading = true;

    typeFamilies: DTypeFamilies;

    constructor(
        private dtypeService: DTypeService,
        private _matDialog: MatDialog,
    ) { }

    ngOnInit() {
        this.dtypeService.retrieveDTypeBuilderCollection()
            .pipe(first())
            .subscribe((dTypeFamilies) => {
                this.typeFamilies = dTypeFamilies;
                this.isLoading = false;
            });
    }

    /**
     * Open a dialog for adding a new column to the dtype and add the column to the columns array
     *
     * @param component
     */
    addComponent(component: DTypeComponent) {
        const dialogRef = this._matDialog.open(DtypeFieldEditDialogComponent, {
            autoFocus: false,
            disableClose: true,
            panelClass: 'dtype-field-edit-dialog-panel',
            height: '80vh',
            width: '80vw',
            maxWidth: '1536px',
            data: {
                dtypeUri: component.uri,
                locator: this.locator
            }
        });

        dialogRef.afterClosed()
            .subscribe((result) => {
                if (result) {
                    this.addColumn(result);
                }
            });
    }

    /**
     * Returns a list with the component families
     *
     * @returns
     */
    getFamiliesList(): any {
        return Object.values(this.typeFamilies);
    }

    private addColumn(column: DTypeCol) {
        const columns = this.columns$.getValue();
        columns.push(column);
        this.columns$.next(columns.sort((a, b) => {
            if ((this.columnIsHidden(a) && this.columnIsHidden(b)) || (!this.columnIsHidden(a) && !this.columnIsHidden(b))) {
                return 0;
            } else {
                return this.columnIsHidden(a) ? 1 : -1;
            }
        }));
    }

    private columnIsHidden(column: DTypeCol) {
        return column.name.startsWith('_');
    }

}
